import React from "react";
import { ManualEnrollmentContainer } from "../../../containers";

const ManualEnrollment = (props) => {
  return <ManualEnrollmentContainer {...props} />;
};

export default ManualEnrollment;
